import type { NotificationPreferences } from '@olimhub/shared'
import { apiClient } from '../client'

export const settingsApi = {
  getNotificationPreferences: () =>
    apiClient.get<NotificationPreferences>('/settings/notifications').then((r) => r.data),

  patchNotificationPreferences: (patch: Partial<NotificationPreferences>) =>
    apiClient.patch<NotificationPreferences>('/settings/notifications', patch).then((r) => r.data),
}
